import { baseTheme } from '../base/index.js';
import { colors, darkColors } from './colors.js';
import { typography } from './typography.js';
import { boxShadows, boxShadowsDark } from './misc.js';

const pureGymTheme = {
  ...baseTheme,
  name: 'pureGym',
  mode: 'light',
  colors,
  boxShadows,
  ...typography
};
const pureGymDarkTheme = {
  ...pureGymTheme,
  mode: 'dark',
  colors: darkColors,
  boxShadows: boxShadowsDark
};

export { pureGymDarkTheme, pureGymTheme };
